import { render, staticRenderFns } from "./HistoryItemJob.vue?vue&type=template&id=63e76552&scoped=true"
import script from "./HistoryItemJob.vue?vue&type=script&lang=js"
export * from "./HistoryItemJob.vue?vue&type=script&lang=js"
import style0 from "./HistoryItemJob.vue?vue&type=style&index=0&id=63e76552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e76552",
  null
  
)

export default component.exports